var _defs, _polygon, _polygon2, _polygon3, _polygon4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArtboard1Copy2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 739.78 355.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#231f20;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "739.78 142.22 739.78 355.56 668.67 355.56 668.67 213.33 597.56 213.33 597.56 0 668.67 0 668.67 142.22 739.78 142.22"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "564.29 142.23 422.07 142.23 422.07 213.34 493.18 213.34 493.18 284.45 422.07 284.45 422.07 355.56 554.3 355.56 564.29 355.56 635.41 355.56 635.41 284.45 564.29 284.45 564.29 142.23"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "0 203.34 0 213.33 0 355.56 71.11 355.56 71.11 213.33 142.22 213.33 142.22 355.56 213.33 355.56 213.33 213.33 213.33 203.34 213.33 142.22 0 142.22 0 203.34"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "246.59 213.33 317.7 213.33 317.7 284.45 246.59 284.45 246.59 355.56 388.81 355.56 388.81 213.33 388.81 203.34 388.81 142.22 246.59 142.22 246.59 213.33"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtboard1Copy2);
export default __webpack_public_path__ + "static/media/Artboard 1 copy 2.0dc96ced545bfd8be7929b59afcbf15f.svg";
export { ForwardRef as ReactComponent };